import { parse } from "qs";

export const useQueryParams = <T>() => {
  if (typeof window === "undefined") {
    return {} as T;
  }
  return parse(window.location.search.slice(1)) as T;
};
